var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSchedulePhotocell0 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 12,
    width: 12,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 4,
    stroke: "#2AAEB3",
    strokeWidth: 2,
    fill: "#000000"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSchedulePhotocell0);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/schedule-photocell-0.4021a92dba1ca4d55b8ad2ecf6d92421.svg";